import axios from 'axios'
import qs from 'qs'
import { clone, objectSnakeToCamelCase, getDefaultStrDate } from '@/util/libUtil.js'

const state = () => ({
	package: {
		packageData: null,
		isLoadingPackage: false,
	},
	paths: {
		packagePath: '/api/atenciones/paquete/',
	}
})

const mutations = {
	package(state, val) {
		state.package = clone(val)
	},
	packageData(state, val) {
		state.package.packageData = val
	},
	isLoadingPackage(state, val) {
		state.package.isLoadingPackage = val
	},
}

const actions = {
	async fetchPackage({ state, commit, getters, dispatch }, params) {
		try {
			commit('isLoadingPackage', true)
			const res = await axios.get(getters.getEndpointFromPath(state.paths.packagePath), {
				params: params,
				paramsSerializer: params => {
					return qs.stringify(params, { arrayFormat: 'brackets', skipNulls: true })
				},
			})
			commit('isLoadingPackage', false)
			return objectSnakeToCamelCase(res.data)
		} catch (error) {
			dispatch('util/showStatusSnackBar', {
				statusType: 'error',
				message: 'Error al cargar las ofertas'
			}, { root: true })
			commit('isLoadingPackage', false)
		}
	}
}

const getters = {
	getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
		rootState.general.host + endpoint
	)
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}